/**
 * ModulePageTabs - Tab-navigasjon med info-lenker for module pages
 * @version 2.0.0 - MASTERPROMPT v2.0 compliant
 */
import { Link } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';

export function ModulePageTabs({ 
  tabs, 
  activeTab, 
  onTabChange,
  moduleId,
  guideBasePath,
  tabToGuideMap = {}
}) {
  return (
    <div className="mb-6" data-testid={`${moduleId}-tabs-container`}>
      <div className="flex gap-1.5" style={{ flexWrap: 'nowrap', overflow: 'hidden' }}>
        {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const guideSection = tabToGuideMap[tab.id] || tab.id;
          
          return (
            <div key={tab.id} className="relative" style={{ flex: 1, minWidth: 0 }}>
              <button
                onClick={() => onTabChange(tab.id)}
                data-testid={`${moduleId}-tab-${tab.id}`}
                className={`
                  w-full flex items-center justify-center gap-2 px-2 py-2.5 rounded-lg text-xs font-medium
                  transition-all duration-200 ease-out
                  ${isActive 
                    ? 'bg-[var(--copper)] text-white shadow-lg shadow-[var(--copper)]/25' 
                    : 'bg-[var(--bg-surface)] text-[var(--text-muted)] hover:text-[var(--text-main)] hover:bg-[var(--bg-highlight)] border border-[var(--border-subtle)] hover:border-[var(--copper)]/40'
                  }
                `}
              >
                {Icon && <Icon className={`w-4 h-4 flex-shrink-0 ${isActive ? 'opacity-100' : 'opacity-70'}`} />}
                <span className="truncate">{tab.label}</span>
              </button>
              {/* Info icon - deeplink to guide */}
              {guideBasePath && (
                <Link
                  to={`${guideBasePath}#${guideSection}`}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                  className={`
                    absolute -top-1 -right-1 w-4 h-4 rounded-full flex items-center justify-center
                    bg-[var(--bg-highlight)] border border-[var(--border-subtle)]
                    hover:bg-[var(--copper)]/20 hover:border-[var(--copper)]/40
                    transition-all duration-200
                    ${isActive ? 'opacity-70' : 'opacity-50 hover:opacity-100'}
                  `}
                  title={`Les mer om ${tab.label}`}
                  data-testid={`${moduleId}-tab-info-${tab.id}`}
                >
                  <HelpCircle className="w-2.5 h-2.5 text-[var(--text-muted)]" />
                </Link>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ModulePageTabs;
